import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-participacao-empresas',
  templateUrl: './consulta-participacao-empresas.component.html',
  styleUrls: ['./consulta-participacao-empresas.component.scss']
})
export class ConsultaParticipacaoEmpresasComponent implements OnInit {

  title = "PARTICIPAÇÕES EM EMPRESAS";
  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    if(!this.consulta.registros || this.consulta.registros.length == 0) {
      this.codigoControle = 'SEMREGISTRO_OK';
    }
    
    if(this.codigoControle == "SEMREGISTRO_OK") {
      this.status = 'success';
    }
  }

}
